import { themaFeestThemas } from "../../data/content";

const scrollToContact = (naam) => {
  const el = document.getElementById("contact");
  if (el) el.scrollIntoView({ behavior: "smooth" });
  window.dispatchEvent(
    new CustomEvent("prefill-aanvraag", {
      detail: { soort: "Themafeest", bericht: `Ik heb interesse in het themafeest: ${naam}.` },
    })
  );
};

export const Themas = () => {
  return (
    <section id="themas" data-testid="themas-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <span className="text-primary font-semibold text-sm uppercase tracking-wide">Themafeesten</span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mt-3">
            Kies een thema voor jouw avond
          </h2>
          <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
            Ieder themafeest wordt professioneel opgebouwd, ingericht en verzorgd door een ervaren, professionele partij. De complete aankleding, sfeer, decoratie en organisatie worden volledig voor je geregeld — zo ben je verzekerd van een verzorgde en hoogwaardige totaalbeleving.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {themaFeestThemas.map((t) => (
            <button
              key={t.naam}
              data-testid={`thema-${t.naam.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => scrollToContact(t.naam)}
              className="group text-left bg-card border border-border rounded-2xl overflow-hidden hover:shadow-md hover:-translate-y-1 transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={t.afbeelding}
                  alt={t.naam}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-xl font-semibold">{t.naam}</h3>
                <p className="mt-2 text-muted-foreground leading-relaxed">{t.beschrijving}</p>
                <span className="mt-3 inline-block text-sm font-medium text-primary group-hover:underline">
                  Vraag dit thema aan →
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
